import React from "react"
import CloseModal from "./CloseModal"

interface Props {
  title: string
  description: React.ReactNode
  setShowModal: (show: boolean) => void
  textAlign?: "center" | "left"
}

const InfoModal: React.FC<Props> = ({
  title,
  description,
  setShowModal,
  textAlign = "center",
}) => {
  return (
    <div className="fixed w-screen h-screen top-0 left-0 zoee-backdrop-filter z-[9001] flex items-center justify-center">
      <div className="px-[40px] md:px-[100px] py-[80px] max-h-[90vh] w-[90%] md:w-[800px] max-w-[95%] bg-white main-shadow rounded-[16px] flex flex-col items-center relative overflow-y-auto">
        <CloseModal
          callback={setShowModal}
          styling="absolute top-[24px] right-[24px]"
        />
        <h1 className="text-black text-[18px] md:text-[28px] font-semibold text-center mb-[36px]">
          {title}
        </h1>
        <div
          className={`w-full flex flex-col gap-[40px] text-[18px] ${
            textAlign === "left" ? "text-left" : "text-center"
          }`}
        >
          {description}
        </div>
      </div>
    </div>
  )
}

export default InfoModal
